import { render, staticRenderFns } from "./HomeworkAnswer.vue?vue&type=template&id=0f436b1e&scoped=true&"
import script from "./HomeworkAnswer.vue?vue&type=script&lang=js&"
export * from "./HomeworkAnswer.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkAnswer.vue?vue&type=style&index=0&id=0f436b1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f436b1e",
  null
  
)

export default component.exports